// export const API_URL = 'http://localhost:3010/api';
export const API_URL = 'https://testing.propietarios.adxpace.com/api';
// export const API_URL = 'https://propietarios.adxpace.com/api';
